import React, { SyntheticEvent } from 'react';

import { LazyImage, Spinner, Button, useDevice } from '@tecma/ds';
import classNames from 'classnames';

import { SwiperCarousel } from 'components/SwiperCarousel';

import type { SwiperController } from 'hooks/useSwiperController';

import './card-apartment-carousel.scss';

interface CardApartmentCarouselRequiredProps {
  images: string[];
  next: () => void;
  prev: () => void;
  carouselImageIndex: number;
  setCarouselImageIndex: (index: number) => void;
}

// Optional Props
interface CardApartmentCarouselOptionalProps {
  className?: string;
  swiperController?: SwiperController;
}

// Combined required and optional props to build the full prop interface
export interface CardApartmentCarouselProps extends CardApartmentCarouselRequiredProps, CardApartmentCarouselOptionalProps {}

export const CardApartmentCarousel: React.FC<CardApartmentCarouselProps> = ({
  images,
  className,
  next,
  prev,
  carouselImageIndex,
  setCarouselImageIndex,
  swiperController,
}) => {
  const device = useDevice();
  const cardApartmentCarouselClassList = classNames('card-apartment-carousel', {
    [`${className}`]: className,
  });
  // FIXME:
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const ok = {
    next,
    prev,
    carouselImageIndex,
    setCarouselImageIndex,
  };

  const carouselItems = images.map((img) => <LazyImage.Image src={img} key={img} loadingElement={<Spinner />} />);

  return (
    <SwiperCarousel
      className={cardApartmentCarouselClassList}
      items={carouselItems}
      swiperProps={{
        loop: true,
        pagination: true,
        allowTouchMove: device.type !== 'desktop',
      }}
      swiperController={swiperController}
      hideArrowButtons={device.type !== 'desktop'}
    />
  );
};

export interface CardApartmentCarouselWrapperProps extends CardApartmentCarouselProps {
  onClick?: (e: SyntheticEvent) => void;
}

const CardApartmentCarouselWrapper: React.FC<CardApartmentCarouselWrapperProps> = ({ onClick, ...rest }) => {
  const device = useDevice();

  if (onClick && device.type !== 'desktop') {
    return (
      <Button className='carousel-wrapper-action-button' onClick={(e) => onClick(e)} color='transparent' fluid>
        <CardApartmentCarousel {...rest} />
      </Button>
    );
  }
  return (
    <>
      <CardApartmentCarousel {...rest} />
      {onClick && <Button className='carousel-action-button' onClick={onClick} iconName='fullscreen' color='inverse' size='small' />}
    </>
  );
};

export default React.memo(CardApartmentCarouselWrapper);
